module.exports = __webpack_public_path__ + "static/sample-1a4bcbbacdee608e07814c93a603ee56.jpg";